// src/utils/index.js
import * as service from '../services'
import axiosInstance from '../services/axiosInstance'
import { BASE_URL } from '../actions/global'
import loja_photo from '../assets/images/DJI_0519b.jpg'
import loja_photo2 from '../assets/images/DJI_0538b.jpg'

export const GEOJSON_PROPERTIES_DEFAULT = 7
export const createRecordTree = async data => {
  try {
    return await axiosInstance.post(`${BASE_URL}/upload-records`, data)
  } catch (err) {
    console.log('Error: ', err)
  }
}

export const MENUITEMS = [
  { value: 'pseudonym', label: 'Nombre Común' },
  { value: 'specie', label: 'Nombre Científico' },
  { value: 'family', label: 'Familia' },
  { value: 'site', label: 'Sitio' },
  // { value: 'zonetype', label: 'Contexto vial' },
  // { value: 'sitetype', label: 'Emplazamiento' },
  { value: 'feature', label: 'Características' },
  { value: 'phytosanitary', label: 'Fitosanitario' },
  { value: 'diseases', label: 'Enfermedades' },
  { value: 'pests', label: 'Plagas' },
  { value: 'physical_problems', label: 'Problemas físicos' },
  { value: 'potential_risks', label: 'Riesgos potenciales' },
  { value: 'suggestions', label: 'Recomendaciones' },
]

export const infoOptions = {
  code: {
    func: async () => await service.getOptionsCodes(),
    name: 'Seleccione uno o varios',
  },
  specie: {
    func: async () => await service.getOptionsSpecies(),
    name: 'Seleccione uno o varios',
  },
  family: {
    func: async () => await service.getOptionsfamily(),
    name: 'Seleccione uno o varios',
  },
  pseudonym: {
    func: async () => await service.getOptionsPseudonym(),
    name: 'Seleccione uno o varios',
  },
  site: {
    func: async () => await service.getOptionsSite(),
    name: 'Seleccione uno o varios',
  },
  zonetype: {
    func: async () => await service.getZoneTypesAsFilterOptions(),
    name: 'Seleccione una opción',
  },
  sitetype: {
    func: async () => await service.getSiteTypesAsFilterOptions(),
    name: 'Seleccione una opción',
  },
  feature: {
    func: async () => await service.getOptionsMetaFeaturesAll(),
    name: 'Seleccione una opción',
  },
  phytosanitary: {
    func: async () => await service.getOptionsCategoryAll(1),
    name: 'Seleccione una opción',
  },
  diseases: {
    func: async () => await service.getOptionsCategoryAll(2),
    name: 'Seleccione una opción',
  },
  pests: {
    func: async () => await service.getOptionsCategoryAll(4),
    name: 'Seleccione una opción',
  },
  physical_problems: {
    func: async () => await service.getOptionsCategoryAll(6),
    name: 'Seleccione una opción',
  },
  potential_risks: {
    func: async () => await service.getOptionsCategoryAll(7),
    name: 'Seleccione una opción',
  },
  suggestions: {
    func: async () => await service.getOptionsCategoryAll(8),
    name: 'Seleccione una opción',
  },
}

export const researchersNames = [
  {
    name: 'Mg. Sc. Andrés Armijos (Director)',
    orcid: 'https://orcid.org/0000-0001-8742-1382',
  },
  {
    name: 'Dr. Darwin Pucha (Coordinador)',
    orcid: 'http://orcid.org/0000-0003-3212-1184',
  },
  {
    name: 'Dr. Deicy Lozano Sivisaca',
    orcid: 'https://orcid.org/0000-0002-3294-9312',
  },
  {
    name: 'Ph.D. Nohemí Jumbo Benítez',
    orcid: 'https://orcid.org/0000-0001-7921-122X',
  },
  {
    name: 'Mg. Sc. Alexandra Jiménez Torres',
    orcid: 'https://orcid.org/0000-0002-3877-1084',
  },
  {
    name: 'Mg. Sc. Wilman Chamba Zaragocín',
    orcid: 'https://orcid.org/0000-0002-1733-1485',
  },
  {
    name: 'Mg. Sc. Fernando González Soto',
    orcid: 'https://orcid.org/0000-0002-1733-1485',
  },
]

export const thesisStudents = [
  {
    name: 'Aguirre González Viviana A.',
    thesis: 'https://dspace.unl.edu.ec/jspui/handle/123456789/26196',
  },
  {
    name: 'Ávila Rosales Ligia M.',
    thesis: '',
  },
  {
    name: 'Cabrera Puglla Odallys F.',
    thesis: '',
  },
  {
    name: 'Carpio Vega Briggette M.',
    thesis: '',
  },
  {
    name: 'Celi Ramirez Laura K.',
    thesis: 'https://dspace.unl.edu.ec/jspui/handle/123456789/26496',
  },
  {
    name: 'Chamba Shonda Patricia E.',
    thesis: 'https://dspace.unl.edu.ec/jspui/handle/123456789/26005',
  },
  {
    name: 'Chicaiza Sánchez Jorge L.',
    thesis: '',
  },
  {
    name: 'Chimbo Granda Edgar F.',
    thesis: 'https://dspace.unl.edu.ec/jspui/handle/123456789/26186',
  },
  {
    name: 'Cordero Calva Jonathan D.',
    thesis: '',
  },
  {
    name: 'Cueva Briceño Eva F.',
    thesis: 'https://dspace.unl.edu.ec/jspui/handle/123456789/26077',
  },
  {
    name: 'Gualan Tene Sheni B.',
    thesis: '',
  },
  {
    name: 'González Guamán Johnny F.',
    thesis: 'https://dspace.unl.edu.ec/jspui/handle/123456789/26629',
  },
  {
    name: 'Gualán Gordillo Ronald F.',
    thesis: '',
  },
  {
    name: 'Guamán Saraguro Karla C.',
    thesis: '',
  },
  {
    name: 'Illescas Cueva Eimy M.',
    thesis: '',
  },
  {
    name: 'Lima Veintimilla Erika V.',
    thesis: '',
  },
  {
    name: 'Macas Vera María F.',
    thesis: '',
  },
  {
    name: 'Merino Galvez Bryan J.',
    thesis: '',
  },
  {
    name: 'Ordoñez Guamán Erika M.',
    thesis: '',
  },
  {
    name: 'Ordoñez González Deysy L.',
    thesis: '',
  },
  {
    name: 'Quizhpe Belduma Gina M.',
    thesis: '',
  },
  {
    name: 'Rivera Guamán Ramiro R.',
    thesis: '',
  },
  {
    name: 'Troya Alverca Danny I.',
    thesis: 'https://dspace.unl.edu.ec/jspui/handle/123456789/26627',
  },
]

export const contributors = [
  { name: 'Arias Godoy Cristina J.' },
  { name: 'Armijos Josué' },
  { name: 'Armijos Nayeli' },
  { name: 'Asanza León Lesly F.' },
  { name: 'Barcenas Cartuche Jefferson P.' },
  { name: 'Cabrera Odallys' },
  { name: 'Campoverde Dalton' },
  { name: 'Cano Cinthya' },
  { name: 'Chicaiza Sanchez Jorge L.' },
  { name: 'Chimbo Fabian' },
  { name: 'Chuquimarca Montalván Karla B.' },
  { name: 'Coronel Armijos Andrea G.' },
  { name: 'Faican Edwin' },
  { name: 'González Armijos Abigail C.' },
  { name: 'Granda Leonardo' },
  { name: 'Gualán Gordillo Ronald F.' },
  { name: 'Guarnizo Brayan' },
  { name: 'Jaramillo Jean' },
  { name: 'Loaiza Sánchez Marcia J.' },
  { name: 'Loján Díaz Ronny S.' },
  { name: 'Macas Vera María F.' },
  { name: 'Merino Galvez Bryan J.' },
  { name: 'Quizhpe Toledo Mirca S.' },
  { name: 'Ramón Karina' },
  { name: 'Reyes Andrade Diego I.' },
  { name: 'Rodríguez Emily' },
  { name: 'Sanchez Nicolas' },
  { name: 'Sarango Deysi' },
  { name: 'Troya Jackson' },
  { name: 'Vaca Sarango Maritza S.' },
  { name: 'Vivanco Celi Yelena M.' },
]

export const imagesGallery = [
  {
    src: loja_photo,
    title: 'Arbolado urbano de la ciudad de Loja',
    author: 'Proyecto 17-DI-FARNR-2021',
  },
  {
    src: loja_photo2,
    title: 'Arbolado urbano de la ciudad de Loja',
    author: 'Proyecto 17-DI-FARNR-2021',
  },
]
